import axios from 'axios';
import { API_BASE_URL } from '../config';

// 创建用于本地API调用的axios实例
export const localApi = axios.create({
  baseURL: API_BASE_URL
});

// 创建用于外部题库API调用的axios实例
export const questionApi = axios.create({
  baseURL: 'https://timu-api.flybirdai.com'
});

// 为本地API添加token拦截器
localApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// 导出默认的axios实例（可选，用于向后兼容）
export default localApi; 